import {
	type FieldIndentifier,
	type FilterIdentifiersByTable,
	parseFieldIdentifier,
	parseTableIdentifier,
	type TableIdentifier,
} from "@packages/lib";
import { logger } from "~/lib/logger";
import type { Configs, FieldConfig } from "./store";
import { loadConfigsFromDexie } from "./utils";

let dexieDataInMemoryCache: Configs | null = null;

export async function loadDexieDataToMemoryCache() {
	if (dexieDataInMemoryCache !== null) {
		return;
	}
	const t1 = performance.now();
	dexieDataInMemoryCache = await loadConfigsFromDexie();
	const t2 = performance.now();
	logger.debug(`Dexie data loaded to in-memory cache in ${(t2 - t1).toFixed(2)} ms`);
}

export function getConfigByField(field: FieldIndentifier): FieldConfig | null {
	if (dexieDataInMemoryCache === null) {
		throw new Error("`getConfigByField()` called before dexie data was loaded in memory cache");
	}

	const { schemaName, tableName, fieldName } = parseFieldIdentifier(field);
	return dexieDataInMemoryCache?.[schemaName]?.[tableName]?.[fieldName] || null;
}

export function getConfigsByTable<T extends TableIdentifier>(
	table: T,
): Record<FilterIdentifiersByTable<T>, FieldConfig | undefined> {
	if (dexieDataInMemoryCache === null) {
		throw new Error("`getConfigsByTable()` called before dexie data was loaded in memory cache");
	}

	const { schemaName, tableName } = parseTableIdentifier(table);
	const tableConfigs = dexieDataInMemoryCache?.[schemaName]?.[tableName];
	if (!tableConfigs) return {} as any;
	return tableConfigs as Record<string, FieldConfig>;
}
